<div class="row">
    <div class="col-md-6">
        <app-location-basic-info [location]="location" [canEdit]="canEdit"></app-location-basic-info>
    </div>
</div>
